// extracted by mini-css-extract-plugin
export default {"UserList":"UserList_UserList__C0j3o"};